import { render } from "./ChatHistory.vue?vue&type=template&id=da196870&scoped=true&ts=true"
import script from "./ChatHistory.vue?vue&type=script&lang=ts"
export * from "./ChatHistory.vue?vue&type=script&lang=ts"

import "./ChatHistory.vue?vue&type=style&index=0&id=da196870&scoped=true&lang=css"
import "./ChatHistory.vue?vue&type=style&index=1&id=da196870&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da196870"]])

export default __exports__